import { type SelectProps } from 'antd';
import type { BaseSelectRef } from 'rc-select';
import { forwardRef } from 'react';

import { filterOptionByLabel } from '@/utils/selectOption';

import { SelectStyled } from './styles';

interface Props extends Omit<SelectProps, 'mode'> {
  isMultiple?: boolean;
}

const Select = forwardRef<BaseSelectRef, Props>(
  ({ placeholder, options = [], isMultiple = false, ...restProps }, ref) => (
    <SelectStyled
      ref={ref}
      mode={isMultiple ? 'multiple' : undefined}
      placeholder={placeholder ?? `All (${options.length})`}
      options={options}
      filterOption={filterOptionByLabel}
      {...restProps}
      showSearch
      virtual
    />
  )
);

Select.displayName = 'Select';

export default Select;
